import { createMedia } from '@artsy/fresnel';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Help from './Help';
import ErrorWrapper from 'error-handling/index';
import { DomainContext } from 'common/layouts/LayoutContext';
import { DomainList } from 'common/constants/domain';
import { useSelector } from 'react-redux';
import { isUserAuthenticated } from '../../selectors/auth';

// todo: I believe these are unused components that can be removed but @nate should weigh in
import NavigationMenu from '../../components/NavigationMenu';
import { Menu } from 'semantic-ui-react';

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
const DesktopContainer = () => (
  <Media greaterThan="mobile">
    {/*     <Menu fixed="top" inverted>
      <NavigationMenu />
    </Menu>
 */}

    <div style={{ marginTop: '60px', padding: '20px' }}>
      <ErrorWrapper>
        <Outlet />
      </ErrorWrapper>
    </div>
  </Media>
);

const MobileContainer = () => {
  const location = useLocation();
  const topMargin = location.pathname.includes('roi-report') ? '0px' : '100px';

  return (
    <Media at="mobile">
      {/*      <Menu fixed="top" inverted>
        <NavigationMenu />
      </Menu>
  */}

      <div
        style={{
          width: '100%',
          marginTop: topMargin,
          maxWidth: '100%',
          overflowX: 'hidden',
          padding: 10,
        }}
      >
        <Outlet />
      </div>
      <Help />
    </Media>
  );
};

const ResponsiveContainer = ({ children }) => {
  /* Heads up!
   * For large applications it may not be best option to put all
   * page into these containers at
   * they will be rendered twice for SSR.
   */
  const isAuthenticated = useSelector(isUserAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/app');
    }
  }, [isAuthenticated, navigate]);

  const domain = window.location.host;

  return (
    <MediaContextProvider>
      <DomainContext.Provider
        value={DomainList?.[domain] ? DomainList?.[domain] : Object.values(DomainList)[0]}
      >
        <DesktopContainer>{children}</DesktopContainer>
        <MobileContainer>{children}</MobileContainer>
      </DomainContext.Provider>
    </MediaContextProvider>
  );
};

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

export default ResponsiveContainer;
